interface lottoType {
    SLUG_API: string;
    SLUG_GAME: string;
    GAME_TITLE: string;
    INSTANT_BALL_RENDER: number;
    INSTANT_BALL_PICK: number;
    INSTANT_DRAWS: number;
    INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE: number;
    INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT: number;
}

export const LOTTO_INSTANT: lottoType = {
    SLUG_API: 'instant-lotto',
    SLUG_GAME: 'yafun-yafun',
    GAME_TITLE: 'Yafun Yafun',
    INSTANT_BALL_RENDER: 80,
    INSTANT_BALL_PICK: 6,
    INSTANT_DRAWS: 1,
    INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE: 5,
    INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT: 8
};
